import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

import { CampaignsSummary } from '../../../../../services/api/Dashboard/CampaignsSummary';

export async function getAuthHeaders() {
  const session = await fetchAuthSession({ forceRefresh: true });
  const token = session.tokens.accessToken.toString();
  const clientId = session.tokens.idToken.toString();

  return {
    Authorization: token,
    clientid: clientId,
    Client_ID: clientId,
  };
}

export async function getCampaignSummary(body) {
  return CampaignsSummary(body);
}

export async function downloadCampaignSummary(body) {
  const headers = await getAuthHeaders();
  const url = process.env.REACT_APP_BACKEND_URL;

  return axios.post(`${url}/painel/data/messages/general/download`, body, {
    headers: {
      Authorization: headers.Authorization,
      clientid: headers.clientid,
    },
  });
}

export async function getSentMessagesLines(body) {
  const headers = await getAuthHeaders();
  const url = process.env.REACT_APP_BACKEND_AWS_URL;

  return axios.post(`${url}/dashboard/messages/sent/lines`, body, {
    headers: {
      Authorization: headers.Authorization,
      Client_ID: headers.Client_ID,
    },
  });
}
